const BELOW_CLASS = 'drainage-pins__callout--below';

function init() {
	document.querySelectorAll('[data-drainage-pins] .drainage-pins__marker').forEach((marker) => {
		//callout height depends on how much copy an author wrote, so the flip has to be measured
		marker.addEventListener('mouseenter', () => positionCallout(marker));
		marker.addEventListener('focusin', () => positionCallout(marker));
	});
}

/**
 * Callouts sit above the pin by default. A pin near the top of the illustration
 * leaves no room, so the bubble is flipped underneath instead.
 */
function positionCallout(marker) {
	const callout = marker.querySelector('.drainage-pins__callout');
	const stage = marker.closest('.drainage-pins__stage');

	if (!callout || !stage) return;

	callout.classList.remove(BELOW_CLASS);

	const stageBox = stage.getBoundingClientRect();

	if (callout.getBoundingClientRect().top >= stageBox.top) return;

	callout.classList.add(BELOW_CLASS);

	//flipping is only an improvement if the bubble actually fits below the pin
	if (callout.getBoundingClientRect().bottom > stageBox.bottom) {
		callout.classList.remove(BELOW_CLASS);
	}
}

export { init };
